<main class="c-main">
  <div class="container-fluid">
    <div class="row">
      <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
        {{ erro }}
      </div>
    </div>
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>inventory</mat-icon></div>
          <mat-card-title>
            Estoque
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-12" style="display: flex;">
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>ID</mat-label>
                    <input formControlName="id" matInput readonly>
                  </mat-form-field>
                </div>
                <div class="col-3">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Cod Fornecedor</mat-label>
                    <input maxlength="13" formControlName="supplier" mask="separator.0" matInput
                      placeholder="ex: 0000000000000" (change)="buscarFornecedor()">
                  </mat-form-field>
                </div>
                <div class="col-7">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Fornecedor</mat-label>
                    <input matInput value="{{nameFornecedor}}" disabled>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-12" style="display: flex;">
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Cod produto</mat-label>
                    <input maxlength="13" formControlName="product" mask="separator.0" matInput
                      placeholder="ex: 0000000000000" (change)="buscarProduto()">
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Produto</mat-label>
                    <input matInput value="{{nameProduct}}" disabled>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Quantidade</mat-label>
                    <input formControlName="qdtProduct" matInput>
                  </mat-form-field>
                </div>
                <div class="col-2">
                  <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                    <mat-label>Valor Total</mat-label>
                    <span matPrefix>R$ &nbsp;</span>
                    <input formControlName="amountPaid" matInput currencyMask placeholder="Digite o valor"
                      [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" required>
                    <mat-error *ngIf="formulario.controls.amountPaid.hasError('required')">Preço é
                      obrigatório! Informe 0 para itens sem preço.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>

            <div class="wow-form-acoes">
              <button type="button" mat-stroked-button (click)="voltarConsulta()">
                <mat-icon>arrow_back</mat-icon> Voltar
              </button>
              <button type="button" (click)="limparFormulario()" mat-stroked-button>
                <mat-icon>insert_drive_file</mat-icon> Limpar
              </button>
              <button [disabled]="!formulario.valid" mat-raised-button color="primary">
                <mat-icon>save</mat-icon> Salvar
              </button>
            </div>
          </form>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
